import { createContext, useReducer, useContext } from "react";
import { AppSettings, User } from "../services/swagger";
import { Socket } from "socket.io-client";

interface ConfirmOptions {
  title?: string;
  text?: string;
  function: () => any;
}

interface GlobalContext {
  user: User | undefined;
  sidebar: boolean;
  refresh: boolean;
  settings?: AppSettings;
  socket?: Socket;
  language: string;
  confirm?: ConfirmOptions;
  // True once the initial session check (getSession) has settled, so route
  // guards can react to a missing user without flashing mid-load.
  sessionChecked?: boolean;
}

export const globalObject: GlobalContext = {
  user: undefined,
  sidebar: false,
  refresh: false,
  language: localStorage.getItem("language") || "en",
  sessionChecked: false,
};

export const globalContext = createContext(globalObject);
export const dispatchContext = createContext<any>(undefined);

export default function AuthStateProvider({ children }: { children: any }) {
  const [state, dispatch] = useReducer(
    (state: any, newValue: any) => ({ ...state, ...newValue }),
    globalObject
  );
  return (
    <globalContext.Provider value={state}>
      <dispatchContext.Provider value={dispatch}>
        {children}
      </dispatchContext.Provider>
    </globalContext.Provider>
  );
}

export const useGlobalContext = () => {
  return {
    context: useContext(globalContext),
    // Partial updates are merged by the reducer; requiring the full state
    // here forced callers to spread a possibly stale context snapshot.
    setContext: useContext<(newState: Partial<GlobalContext>) => void>(
      dispatchContext,
    ),
  };
};
